export default __webpack_public_path__ + "static/media/StatisticsAnalysis.86befa57.svg";